// Default props for icons.
const defaultProps = {
  width: 16,
  height: 16,
  fill: undefined,
}

export default defaultProps
